import React, { useState } from 'react';
import { 
  Plus, 
  Edit, 
  Trash2, 
  Eye, 
  Users, 
  Package, 
  Calendar, 
  Search,
  Download,
  Mail,
  Phone,
  MapPin,
  X,
  UserPlus
} from 'lucide-react';

const Salons = () => {
  const [salons, setSalons] = useState([
    {
      id: 1,
      name: 'Beauty Haven',
      email: 'contact@beautyhaven.com',
      phone: '+1 (555) 123-4567',
      address: '123 Main St, Downtown, NY 10001',
      package: 'Professional',
      packageId: 2,
      status: 'active',
      users: [
        { id: 1, name: 'Sarah Johnson', email: 'sarah@beautyhaven.com', role: 'admin', status: 'active' },
        { id: 2, name: 'Mike Davis', email: 'mike@beautyhaven.com', role: 'employee', status: 'active' },
        { id: 3, name: 'Emma Wilson', email: 'emma@beautyhaven.com', role: 'employee', status: 'active' },
        { id: 4, name: 'John Smith', email: 'john@beautyhaven.com', role: 'employee', status: 'active' },
        { id: 5, name: 'Lisa Brown', email: 'lisa@beautyhaven.com', role: 'employee', status: 'active' }
      ],
      registrationDate: '2024-06-15',
      lastLogin: '2025-01-15',
      billingStatus: 'paid',
      nextBilling: '2025-02-15',
      revenue: '$8,920',
      growth: '+18%'
    },
    {
      id: 2,
      name: 'Style Studio',
      email: 'info@stylestudio.com',
      phone: '+1 (555) 234-5678',
      address: '456 Oak Ave, Midtown, NY 10002',
      package: 'Starter',
      packageId: 1,
      status: 'active',
      users: [
        { id: 1, name: 'Alex Turner', email: 'alex@stylestudio.com', role: 'admin', status: 'active' },
        { id: 2, name: 'Maria Garcia', email: 'maria@stylestudio.com', role: 'employee', status: 'active' }
      ],
      registrationDate: '2024-08-20',
      lastLogin: '2025-01-14',
      billingStatus: 'pending',
      nextBilling: '2025-02-20',
      revenue: '$5,670',
      growth: '+12%'
    },
    {
      id: 3,
      name: 'Glamour Salon',
      email: 'hello@glamoursalon.com',
      phone: '+1 (555) 345-6789',
      address: '789 Park Blvd, Uptown, NY 10003',
      package: 'Enterprise',
      packageId: 3,
      status: 'active',
      users: [
        { id: 1, name: 'David Lee', email: 'david@glamoursalon.com', role: 'admin', status: 'active' },
        { id: 2, name: 'Sophie Chen', email: 'sophie@glamoursalon.com', role: 'manager', status: 'active' },
        { id: 3, name: 'Tom Wilson', email: 'tom@glamoursalon.com', role: 'employee', status: 'active' },
        { id: 4, name: 'Anna Davis', email: 'anna@glamoursalon.com', role: 'employee', status: 'active' },
        { id: 5, name: 'Chris Brown', email: 'chris@glamoursalon.com', role: 'employee', status: 'active' },
        { id: 6, name: 'Rachel Green', email: 'rachel@glamoursalon.com', role: 'employee', status: 'active' },
        { id: 7, name: 'Kevin White', email: 'kevin@glamoursalon.com', role: 'employee', status: 'active' },
        { id: 8, name: 'Amanda Black', email: 'amanda@glamoursalon.com', role: 'employee', status: 'active' }
      ],
      registrationDate: '2024-05-10',
      lastLogin: '2025-01-13',
      billingStatus: 'paid',
      nextBilling: '2025-02-10',
      revenue: '$12,450',
      growth: '+23%'
    },
    {
      id: 4,
      name: 'Elegance Spa',
      email: 'contact@elegancespa.com',
      phone: '+1 (555) 456-7890',
      address: '321 River Rd, Riverside, NY 10004',
      package: 'Professional',
      packageId: 2,
      status: 'pending',
      users: [
        { id: 1, name: 'Jennifer Adams', email: 'jennifer@elegancespa.com', role: 'admin', status: 'active' },
        { id: 2, name: 'Robert Taylor', email: 'robert@elegancespa.com', role: 'employee', status: 'active' },
        { id: 3, name: 'Michelle Clark', email: 'michelle@elegancespa.com', role: 'employee', status: 'active' },
        { id: 4, name: 'Daniel Lewis', email: 'daniel@elegancespa.com', role: 'employee', status: 'active' }
      ],
      registrationDate: '2025-01-12',
      lastLogin: '2025-01-12',
      billingStatus: 'pending',
      nextBilling: '2025-02-12',
      revenue: '$7,340',
      growth: '+15%'
    }
  ]);

  const [showAddSalonModal, setShowAddSalonModal] = useState(false);
  const [showEditSalonModal, setShowEditSalonModal] = useState(false);
  const [showDeleteSalonModal, setShowDeleteSalonModal] = useState(false);
  const [showSalonDetailsModal, setShowSalonDetailsModal] = useState(false);
  const [selectedSalon, setSelectedSalon] = useState(null);
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterPackage, setFilterPackage] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  const [newSalon, setNewSalon] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    package: 'Starter',
    status: 'active'
  });

  const packages = [
    { id: 1, name: 'Starter', userLimit: 2, price: 49 },
    { id: 2, name: 'Professional', userLimit: 5, price: 99 },
    { id: 3, name: 'Enterprise', userLimit: 10, price: 199 }
  ];

  const handleAddSalon = () => {
    setShowAddSalonModal(true);
    setNewSalon({
      name: '',
      email: '',
      phone: '',
      address: '',
      package: 'Starter',
      status: 'active'
    });
  };

  const handleEditSalon = (salon) => {
    setSelectedSalon(salon);
    setNewSalon({
      name: salon.name,
      email: salon.email,
      phone: salon.phone,
      address: salon.address,
      package: salon.package,
      status: salon.status
    });
    setShowEditSalonModal(true);
  };

  const handleDeleteSalon = (salon) => {
    setSelectedSalon(salon);
    setShowDeleteSalonModal(true);
  };

  const handleViewSalonDetails = (salon) => {
    setSelectedSalon(salon);
    setShowSalonDetailsModal(true);
  };

  const handleSaveSalon = () => {
    if (showEditSalonModal && selectedSalon) {
      // Edit existing salon
      setSalons(salons.map(salon => 
        salon.id === selectedSalon.id 
          ? { ...salon, ...newSalon }
          : salon
      ));
    } else {
      // Create new salon
      const packageInfo = packages.find(p => p.name === newSalon.package);
      const newSalonObj = {
        ...newSalon,
        id: Date.now(),
        packageId: packageInfo?.id || 1,
        users: [
          {
            id: 1,
            name: 'Admin User',
            email: newSalon.email,
            role: 'admin',
            status: 'active'
          }
        ],
        registrationDate: new Date().toISOString().split('T')[0],
        lastLogin: new Date().toISOString().split('T')[0],
        billingStatus: 'pending',
        nextBilling: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        revenue: '$0',
        growth: '+0%'
      };
      setSalons([...salons, newSalonObj]);
    }
    
    setShowAddSalonModal(false);
    setShowEditSalonModal(false);
    setSelectedSalon(null);
  };

  const handleConfirmDelete = () => {
    setSalons(salons.filter(salon => salon.id !== selectedSalon.id));
    setShowDeleteSalonModal(false);
    setSelectedSalon(null);
  };

  const filteredSalons = salons.filter(salon => {
    const matchesStatus = filterStatus === 'all' || salon.status === filterStatus;
    const matchesPackage = filterPackage === 'all' || salon.package === filterPackage;
    const matchesSearch = salon.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         salon.email.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesStatus && matchesPackage && matchesSearch;
  });

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'bg-green-100 text-green-800';
      case 'pending': return 'bg-yellow-100 text-yellow-800';
      case 'suspended': return 'bg-red-100 text-red-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const getBillingStatusColor = (status) => {
    switch (status) {
      case 'paid': return 'bg-green-100 text-green-800';
      case 'pending': return 'bg-yellow-100 text-yellow-800';
      case 'overdue': return 'bg-red-100 text-red-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const getRoleColor = (role) => {
    switch (role) {
      case 'admin': return 'bg-purple-100 text-purple-800';
      case 'manager': return 'bg-blue-100 text-blue-800';
      case 'employee': return 'bg-green-100 text-green-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Salon Management</h1>
          <p className="text-gray-600">Manage all salon companies and their subscriptions</p>
        </div>
        <button 
          onClick={handleAddSalon}
          className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center space-x-2"
        >
          <Plus className="w-4 h-4" />
          <span>Add Salon</span>
        </button>
      </div>

      {/* Filters and Search */}
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="relative">
            <input
              type="text"
              placeholder="Search salons..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
            />
            <Search className="absolute left-3 top-2.5 w-4 h-4 text-gray-400" />
          </div>
          <select
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
          >
            <option value="all">All Status</option>
            <option value="active">Active</option>
            <option value="pending">Pending</option>
            <option value="suspended">Suspended</option>
          </select>
          <select
            value={filterPackage}
            onChange={(e) => setFilterPackage(e.target.value)}
            className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
          >
            <option value="all">All Packages</option>
            <option value="Starter">Starter</option>
            <option value="Professional">Professional</option>
            <option value="Enterprise">Enterprise</option>
          </select>
        </div>
        <div className="flex items-center space-x-2">
          <button className="px-3 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors flex items-center space-x-2">
            <Download className="w-4 h-4" />
            <span>Export</span>
          </button>
          <div className="text-sm text-gray-500">
            {filteredSalons.length} of {salons.length} salons
          </div>
        </div>
      </div>

      {/* Salons Table */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200">
        <div className="p-6 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-800">All Salons</h3>
        </div>
        <div className="p-6">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-gray-200">
                  <th className="text-left py-3 px-4 font-medium text-gray-700">Salon</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-700">Package</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-700">Users</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-700">Status</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-700">Billing</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-700">Revenue</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-700">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredSalons.map((salon) => (
                  <tr key={salon.id} className="border-b border-gray-100 hover:bg-gray-50">
                    <td className="py-3 px-4">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                          <span className="text-green-600 font-semibold">{salon.name.charAt(0)}</span>
                        </div>
                        <div>
                          <p className="font-medium text-gray-900">{salon.name}</p>
                          <p className="text-sm text-gray-500">{salon.email}</p>
                          <p className="text-xs text-gray-400 flex items-center mt-1">
                            <MapPin className="w-3 h-3 mr-1" />
                            {salon.address.split(',')[0]}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td className="py-3 px-4">
                      <div>
                        <p className="font-medium text-gray-900">{salon.package}</p>
                        <p className="text-xs text-gray-500">{salon.users.length} / {packages.find(p => p.name === salon.package)?.userLimit || '∞'} users</p>
                      </div>
                    </td>
                    <td className="py-3 px-4">
                      <div className="flex items-center space-x-2">
                        <Users className="w-4 h-4 text-gray-400" />
                        <span className="text-gray-700">{salon.users.length}</span>
                      </div>
                    </td>
                    <td className="py-3 px-4">
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(salon.status)}`}>
                        {salon.status}
                      </span>
                    </td>
                    <td className="py-3 px-4">
                      <div>
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${getBillingStatusColor(salon.billingStatus)}`}>
                          {salon.billingStatus}
                        </span>
                        <p className="text-xs text-gray-500 mt-1">Next: {salon.nextBilling}</p>
                      </div>
                    </td>
                    <td className="py-3 px-4">
                      <div>
                        <p className="font-medium text-gray-900">{salon.revenue}</p>
                        <p className="text-xs text-green-600">{salon.growth}</p>
                      </div>
                    </td>
                    <td className="py-3 px-4">
                      <div className="flex space-x-2">
                        <button 
                          onClick={() => handleViewSalonDetails(salon)}
                          className="p-1 text-blue-600 hover:text-blue-800"
                          title="View Details"
                        >
                          <Eye className="w-4 h-4" />
                        </button>
                        <button 
                          onClick={() => handleEditSalon(salon)}
                          className="p-1 text-green-600 hover:text-green-800"
                          title="Edit Salon"
                        >
                          <Edit className="w-4 h-4" />
                        </button>
                        <button 
                          onClick={() => handleDeleteSalon(salon)}
                          className="p-1 text-red-600 hover:text-red-800"
                          title="Delete Salon"
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Add/Edit Salon Modal */}
      {(showAddSalonModal || showEditSalonModal) && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 w-full max-w-md mx-4">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-800">
                {showEditSalonModal ? 'Edit Salon' : 'Add New Salon'}
              </h3>
              <button 
                onClick={() => {
                  setShowAddSalonModal(false);
                  setShowEditSalonModal(false);
                  setSelectedSalon(null);
                }}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="w-6 h-6" />
              </button>
            </div>
            <form className="space-y-4" onSubmit={(e) => { e.preventDefault(); handleSaveSalon(); }}>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Salon Name</label>
                <input
                  type="text"
                  value={newSalon.name}
                  onChange={(e) => setNewSalon({ ...newSalon, name: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                  placeholder="Enter salon name"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                <input
                  type="email"
                  value={newSalon.email}
                  onChange={(e) => setNewSalon({ ...newSalon, email: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                  placeholder="Enter email address"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Phone</label>
                <input
                  type="tel"
                  value={newSalon.phone}
                  onChange={(e) => setNewSalon({ ...newSalon, phone: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                  placeholder="Enter phone number"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Address</label>
                <textarea
                  value={newSalon.address}
                  onChange={(e) => setNewSalon({ ...newSalon, address: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                  placeholder="Enter full address"
                  rows="2"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Package</label>
                <select
                  value={newSalon.package}
                  onChange={(e) => setNewSalon({ ...newSalon, package: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                >
                  {packages.map(pkg => (
                    <option key={pkg.id} value={pkg.name}>
                      {pkg.name} - ${pkg.price}/month ({pkg.userLimit} users)
                    </option>
                  ))}
                </select>
              </div>
  <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Status</label>
                <select
                  value={newSalon.status}
                  onChange={(e) => setNewSalon({ ...newSalon, status: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                >
                  <option value="active">Active</option>
                  <option value="pending">Pending</option>
                  <option value="suspended">Suspended</option>
                </select>
              </div>
              <div className="flex space-x-3 pt-4">
                <button
                  type="button"
                  onClick={() => {
                    setShowAddSalonModal(false);
                    setShowEditSalonModal(false);
                    setSelectedSalon(null);
                  }}
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                >
                  {showEditSalonModal ? 'Update Salon' : 'Add Salon'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Salon Details Modal */}
      {showSalonDetailsModal && selectedSalon && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 w-full max-w-4xl mx-4 max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl font-semibold text-gray-800">Salon Details: {selectedSalon.name}</h3>
              <button 
                onClick={() => setShowSalonDetailsModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="w-6 h-6" />
              </button>
            </div>
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Salon Information */}
              <div className="space-y-4">
                <h4 className="text-lg font-medium text-gray-800">Salon Information</h4>
                <div className="bg-gray-50 rounded-lg p-4 space-y-3">
                  <div className="flex items-center space-x-3">
                    <Mail className="w-4 h-4 text-gray-400" />
                    <span className="text-gray-700">{selectedSalon.email}</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <Phone className="w-4 h-4 text-gray-400" />
                    <span className="text-gray-700">{selectedSalon.phone}</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <MapPin className="w-4 h-4 text-gray-400" />
                    <span className="text-gray-700">{selectedSalon.address}</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <Package className="w-4 h-4 text-gray-400" />
                    <span className="text-gray-700">{selectedSalon.package}</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <Calendar className="w-4 h-4 text-gray-400" />
                    <span className="text-gray-700">Registered: {selectedSalon.registrationDate}</span>
                  </div>
                </div>
              </div>

              {/* Billing & Revenue */}
              <div className="space-y-4">
                <h4 className="text-lg font-medium text-gray-800">Billing & Revenue</h4>
                <div className="bg-gray-50 rounded-lg p-4 space-y-3">
                  <div className="flex items-center justify-between">
                    <span className="text-gray-600">Billing Status:</span>
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${getBillingStatusColor(selectedSalon.billingStatus)}`}>
                      {selectedSalon.billingStatus}
                    </span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-gray-600">Next Billing:</span>
                    <span className="text-gray-700">{selectedSalon.nextBilling}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-gray-600">Revenue:</span>
                    <span className="font-medium text-gray-900">{selectedSalon.revenue}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-gray-600">Growth:</span>
                    <span className="text-green-600">{selectedSalon.growth}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Users Table */}
            <div className="mt-6">
              <div className="flex items-center justify-between mb-4">
                <h4 className="text-lg font-medium text-gray-800">Users ({selectedSalon.users.length})</h4>
                <button className="px-3 py-1 bg-green-600 text-white text-sm rounded-lg hover:bg-green-700 transition-colors flex items-center space-x-2">
                  <UserPlus className="w-4 h-4" />
                  <span>Add User</span>
                </button>
              </div>
              <div className="bg-gray-50 rounded-lg overflow-hidden">
                <table className="w-full">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="text-left py-3 px-4 font-medium text-gray-700">Name</th>
                      <th className="text-left py-3 px-4 font-medium text-gray-700">Email</th>
                      <th className="text-left py-3 px-4 font-medium text-gray-700">Role</th>
                      <th className="text-left py-3 px-4 font-medium text-gray-700">Status</th>
                      <th className="text-left py-3 px-4 font-medium text-gray-700">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedSalon.users.map((user) => (
                      <tr key={user.id} className="border-b border-gray-200">
                        <td className="py-3 px-4">
                          <div className="flex items-center space-x-3">
                            <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                              <span className="text-green-600 font-semibold text-sm">{user.name.charAt(0)}</span>
                            </div>
                            <span className="font-medium text-gray-900">{user.name}</span>
                          </div>
                        </td>
                        <td className="py-3 px-4 text-gray-700">{user.email}</td>
                        <td className="py-3 px-4">
                          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getRoleColor(user.role)}`}>
                            {user.role}
                          </span>
                        </td>
                        <td className="py-3 px-4">
                          <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                            user.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                          }`}>
                            {user.status}
                          </span>
                        </td>
                        <td className="py-3 px-4">
                          <div className="flex space-x-2">
                            <button className="p-1 text-blue-600 hover:text-blue-800">
                              <Edit className="w-4 h-4" />
                            </button>
                            <button className="p-1 text-red-600 hover:text-red-800">
                              <Trash2 className="w-4 h-4" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteSalonModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 w-full max-w-md mx-4">
            <div className="text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Trash2 className="w-8 h-8 text-red-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Delete Salon</h3>
              <p className="text-gray-600 mb-6">
                Are you sure you want to delete "{selectedSalon?.name}"? This will also remove all associated users and data.
              </p>
              <div className="flex space-x-3">
                <button
                  onClick={() => setShowDeleteSalonModal(false)}
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={handleConfirmDelete}
                  className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
                >
                  Delete Salon
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
  </div>
);
};

export default Salons;
